<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="responsive">
  <BackgroundImage />

  <!-- 住所の重複 -->
  <transition name="popup">
    <NewApplicationPostnumberDuplicated
      v-if="group1.visiblePostnumberDuplicated"
      @closeButtonClicked="group1.visiblePostnumberDuplicated = false"
      @submitButtonClicked="group1.onEstimatePostnumberDuplicatedSubmitted($event)"
      :list="group1.duplicatedAddressList"
    />
  </transition>

    <div id="wrapper">
      <div id="head-logo">
        <router-link to="/pc/login" target="_blank">
          <img src="/lc/app/images/log-1row.svg" alt="LEGAL CONNECTION">
        </router-link>
      </div>
      <!-- content:start -->
      <div id="content">
        <div class="contact">
          <div class="contact-head">
            <div class="breadcrumb">
              <span class="breadcrumb-link current">新規契約申し込み</span>
              <span class="breadcrumb-link">新規契約申し込み内容の確認</span>
              <span class="breadcrumb-link">新規契約申し込みの完了</span>
            </div>
            <h1 class="hdg02">新規契約申し込みフォーム</h1>
            <a href="/lc/about/" target="_blank" class="contact-head-link">LEGAL CONNECTIONについて <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
          </div>
          <div class="contact-container">
            <div class="contact-navigation">
            </div>
            <div class="contact-content">
              <p class="txt" :class="group1.isError ? 'mb16' : 'mb32'">
                必要事項をご記入してお申し込みください。申し込み完了後、即時ご利用開始いただけます。<br>
                ※新日本法規WEB会員で登録した情報の一部が自動で反映されます。
              </p>
              <p class="error-message mb16" v-if="group1.isError">入力内容に不備があるようです。下記メッセージ（赤文字）のご確認をお願いいたします。</p>
              <h2 class="hdg03">新規契約申し込みフォーム</h2>
              <ul class="contact-content-list">
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup v-if="group1.device === 'pc'">
                      <col style="width:30%;">
                      <col style="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          法人名/個人名 <span class="txt-red">[必須]</span>
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="text" v-model="group1.name" placeholder="新日本法規出版株式会社">
                          </div>
                          <p class="txt-sup">
                            法人形態は省略せず入力をお願いします。個人の場合は個人のお名前を入力してください。
                          </p>
                          <p class="error-message" v-if="group1.error_name">{{group1.error_name}}</p>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          読み仮名 <span class="txt-red">[必須]</span>
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="text" v-model="group1.kana" placeholder="シンニッポンホウキシュッパンカブシキガイシャ">
                          </div>
                          <p class="error-message" v-if="group1.error_kana">{{group1.error_kana}}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup v-if="group1.device === 'pc'">
                      <col style="width:30%;">
                      <col style="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          ご担当者名 <span class="txt-red">[必須]</span>
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="text" v-model="group1.charge_name" placeholder="山田太郎">
                          </div>
                          <p class="txt-sup">
                            個人名とご担当者様が同じ場合も、ご入力ください。<br>ご請求書には記載されません。
                          </p>
                          <p class="error-message" v-if="group1.error_charge_name">{{group1.error_charge_name}}</p>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          ご担当部署名
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="text" v-model="group1.department" placeholder="法務部">
                          </div>
                          <p class="txt-sup">
                            ご連絡先となりますので、団体・法人の場合は必要に応じて部署名まで入力してください。
                          </p>
                          <p class="error-message" v-if="group1.error_department">{{group1.error_department}}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup v-if="group1.device === 'pc'">
                      <col style="width:30%;">
                      <col style="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          住所 <span class="txt-red">[必須]</span>
                        </th>
                        <td>
                          <p class="txt-sup">
                            郵便番号から住所検索を実行してください。システムの都合上、半角文字はすべて全角に変換されます。お手元に請求書若しくは納品書がある場合は、記載されているとおりに住所をご入力ください。<br>（例）「３－１－８」と記載されている場合は、正式な表記が「３丁目１番８号」だとしても、「３－１－８」とご入力ください。
                          </p>
                          <p class="txt mt24">郵便番号 <span class="txt-red">[必須]</span></p>
                          <div class="column gutter align-center mt12">
                            <div class="column-item space-gutter" :class="group1.device === 'sp' ? 'col-4' : 'col-3'">
                              <div class="formparts text">
                                <input type="text" v-model="group1.postnumber" placeholder="4608455" maxlength="7">
                              </div>
                            </div>
                            <div class="column-item col-3 space-gutter">
                              <div class="button"
                                @click="group1.fetchAddresses(group1.postnumber)"
                              >
                                <button class="btn" type="button" name="button">住所検索</button>
                              </div>
                            </div>
                            <div class="column-item col-3 space-gutter">
                              <sup class="txt-sup">例:448****</sup>
                            </div>
                          </div>
                          <p class="error-message" v-if="group1.error_postnumber">{{group1.error_postnumber}}</p>
                          <template
                            v-if="group1.visibleAddress"
                          >
                            <p class="txt">市区郡 <span class="txt-red">[必須]</span></p>
                            <div class="formparts text formparts-short">
                              <input type="text" v-model="group1.address" placeholder="名古屋市中区">
                              <p class="error-message" v-if="group1.error_address">{{group1.error_address}}</p>
                            </div>
                            <p class="txt">町村域大字 <span class="txt-red">[必須]</span></p>
                            <div class="formparts text formparts-short">
                              <input type="text" v-model="group1.address2" placeholder="栄">
                              <p class="error-message" v-if="group1.error_address2">{{group1.error_address2}}</p>
                            </div>
                            <p class="txt">小字以下番地 <span class="txt-red">[必須]</span></p>
                            <div class="formparts text formparts-short">
                              <input type="text" v-model="group1.address3" placeholder="１－２３－２０">
                              <p class="error-message" v-if="group1.error_address3">{{group1.error_address3}}</p>
                            </div>
                            <p class="txt">マンション・ビル名等</p>
                            <div class="formparts text formparts-short">
                              <input type="text" v-model="group1.address4" placeholder="新日本ビル３Ｆ">
                              <p class="error-message" v-if="group1.error_address4">{{group1.error_address4}}</p>
                            </div>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup v-if="group1.device === 'pc'">
                      <col style="width:30%;">
                      <col style="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          メールアドレス <span class="txt-red">[必須]</span>
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="email" v-model="group1.email" placeholder="yamada-taro@sn-hoki.co.jp">
                            <p class="error-message" v-if="group1.error_email">{{group1.error_email}}</p>
                          </div>
                          <p class="txt">
                            もう一度入力してください
                          </p>
                          <div class="formparts text formparts-short">
                            <input type="email" v-model="group1.email_check" placeholder="yamada-taro@sn-hoki.co.jp">
                            <p class="error-message" v-if="group1.error_email_check">{{group1.error_email_check}}</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup v-if="group1.device === 'pc'">
                      <col style="width:30%;">
                      <col style="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          職業 <span class="txt-red">[必須]</span>
                        </th>
                        <td>
                          <div class="formparts select formparts-short"
                            @mouseenter="group1.onMouseEnterOccupationClassificationSelectItem"
                            @mouseleave="group1.onMouseLeaveOccupationClassificationSelectItem"
                            @click="group1.onClickOccupationClassificationSelectItem"
                            :class="{ 'is-visible-list': group1.displayOccupationClassificationSelect }"
                          >
                            <div class="select-label" role="select">{{ group1.selectedOccupationClassificationName }}<FontawesomeIcon icon="angle-down" class="icn" /></div>
                            <!-- <div class="select-label" role="select">ライセンス数を選択※アクティブ<FontawesomeIcon icon="angle-up" class="icn" /></div> -->
                            <div class="select-option">
                              <ul class="select-option-list">
                                <li v-for="item in group1.occupationClassificationList" :key="'occupation_classification_' + item.id" role="option">
                                  <label role="button"><input type="radio"
                                    v-model="group1.occupation_classification" :value="item.id"
                                    @change="group1.onOccupationClassificationListSelected()">{{ item.name }}</label>
                                </li>
                              </ul>
                            </div>
                            <p class="error-message" v-if="group1.error_occupation_classification">{{group1.error_occupation_classification}}</p>
                          </div>
                          <div class="formparts select formparts-short"
                            @mouseenter="group1.onMouseEnterOccupationSelectItem"
                            @mouseleave="group1.onMouseLeaveOccupationSelectItem"
                            @click="group1.onClickOccupationSelectItem"
                            :class="{ 'is-visible-list': group1.displayOccupationSelect }"
                          >
                            <div class="select-label" role="select">{{ group1.selectedOccupationName }}<FontawesomeIcon icon="angle-down" class="icn" /></div>
                            <!-- <div class="select-label" role="select">ライセンス数を選択※アクティブ<FontawesomeIcon icon="angle-up" class="icn" /></div> -->
                            <div class="select-option">
                              <ul class="select-option-list">
                                <li v-for="item in group1.occupationList" :key="'occupation_' + item.id" role="option">
                                  <label role="button"><input type="radio"
                                    v-model="group1.occupation" :value="item.id"
                                    @change="group1.onOccupationListSelected()">{{ item.name }}</label>
                                </li>
                              </ul>
                            </div>
                            <p class="error-message" v-if="group1.error_occupation">{{group1.error_occupation}}</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup v-if="group1.device === 'pc'">
                      <col style="width:30%;">
                      <col style="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          電話番号1 <span class="txt-red">[必須]</span>
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="text" v-model="group1.tel" placeholder="052-211-5788" maxlength="13">
                            <p class="error-message" v-if="group1.error_tel">{{group1.error_tel}}</p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          電話番号2
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="text" v-model="group1.tel2" placeholder="090-000-0000" maxlength="13">
                          </div>
                          <p class="txt-sup">日中にご連絡がつきやすい電話番号をご入力ください。（携帯電話等）</p>
                          <p class="error-message" v-if="group1.error_tel2">{{group1.error_tel2}}</p>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          内線番号
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="text" v-model="group1.extension" placeholder="1301" maxlength="5">
                            <p class="error-message" v-if="group1.error_extension">{{group1.error_extension}}</p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          FAX番号
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="text" v-model="group1.fax" placeholder="052-211-5796" maxlength="13">
                            <p class="error-message" v-if="group1.error_fax">{{group1.error_fax}}</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup v-if="group1.device === 'pc'">
                      <col style="width:30%;">
                      <col style="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          弊社社員からの紹介であれば社員名を入力してください
                        </th>
                        <td>
                          <div class="formparts text formparts-short">
                            <input type="text" v-model="group1.introducer" placeholder="山田太郎">
                          </div>
                          <p class="txt-sup">
                            不明の場合は入力不要です。ご請求書には記載されません。
                          </p>
                          <p class="error-message" v-if="group1.error_introducer">{{group1.error_introducer}}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup v-if="group1.device === 'pc'">
                      <col style="width:30%;">
                      <col style="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          備考
                        </th>
                        <td>
                          <div class="formparts textarea">
                            <textarea v-model="group1.note" rows="5" placeholder="ご質問などがありましたら、ご入力ください。"></textarea>
                            <p class="error-message" v-if="group1.error_note">{{group1.error_note}}</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>

              <h2 class="hdg03">希望されるパッケージ / 商品</h2>
              <p class="contact-content-lead sp-ml20 sp-mr20">
                ご契約を希望する「パッケージ/商品」の「新規契約」を押下後、利用を希望するライセンス数（人数）をご指定ください。<br>
                また、お申し込みいただけるライセンス数に制限がありますので、パッケージのライセンス数（固定）以上のご利用を希望される場合は、ご契約完了後、サービス内の管理メニューより追加申し込みいただけます。
              </p>
              <ul class="contact-content-note mb28 sp-ml20 sp-mr20">
                <li>※パッケージごとにライセンス数（固定）が異なります。</li>
                <li>※オプションは１ライセンスよりお申し込みいただけます。</li>
              </ul>
              <div class="mb60" :class="group1.device === 'sp' ? 'sp-scroll-table' : ''">
                <p class="mt4 error-message" v-if="group1.error_productsLicenses">{{group1.error_productsLicenses}}</p>

                <FontawesomeIcon v-if="!group1.isPackageAndLicensesLoaded" :icon="['fal','spinner-third']" size="2x" class="mb12 icn fa-spin" />
                <template v-else>
                  <p v-if="group1.packagesAndProducts.length === 0" class="txt sp-ml20 sp-mr20">表示する内容がありません。</p>
                  <template v-else>

                    <table class="license-content-table border">
                      <colgroup>
                        <col style="width: 24%;">
                        <col style="width: 40%;">
                        <col style="width: 9%;">
                        <col style="width: 15%;">
                        <col>
                        <col style="width: 12%;">
                      </colgroup>
                      <thead>
                        <tr>
                          <th>パッケージ</th>
                          <th>商品</th>
                          <th></th>
                          <th class="ta-center">ライセンス数を指定</th>
                          <th></th>
                          <th class="ta-center">価格（税込）</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in group1.packagesAndProducts" :key="'packages_products_' + index" v-show="item.is_buyable">
                          <th v-if="item.is_first" :rowspan="item.is_bought ? item.products_count : 1">
                            <div class="license-content-table-hdg">{{ item.package_name }}</div>
                          </th>
                          <td :class="item.is_first ? '' : 'pl20'">
                            <div class="license-content-table-title" :class="{'is-inactive': !item.is_buyable}">{{ item.product_name }}</div>
                            <div v-if="!item.is_buyable" class="contact-content-table-sup mt12">{{ item.package_name }}を購入していないため、購入できません。</div>
                          </td>
                          <td class="ta-center">
                            <div v-show="!item.is_bought && item.is_buyable" class="license-content-table-link">
                              <span @click="group1.onBuyButonClicked({item: item})" role="button">新規契約</span>
                            </div>
                          </td>
                          <td class="ta-center">
                            <span v-if="!item.is_bought">-</span>
                            <span v-else-if="item.is_fixed_licenses">{{ item.fixed_licenses }}</span>
                            <div v-else class="license-content-table-select">
                              <div
                                class="formparts select"
                                @mouseenter="group1.onMouseEnterLicenseSelectItem(item)"
                                @mouseleave="group1.onMouseLeaveLicenseSelectItem(item)"
                                @click="group1.onClickLicenseSelectItem(item)"
                                :class="{ 'is-visible-list': item.display_licenses_select }"
                              >
                                <div class="select-label ta-center" role="select">{{ item.licenses }}<FontawesomeIcon icon="angle-down" class="icn" /></div>
                                <div class="select-option">
                                  <ul class="select-option-list ta-center">
                                    <template v-for="n of item.fixed_licenses_basic">
                                      <li :key="`select-option-list-item-${ n }`" v-if="n >= item.fixed_licenses" class="ta-center" role="option">
                                        <label><input type="radio" :name="`product-${ item.product_id }`" :value="n" @change="group1.onLicensesChoicesChanged({item: item, licenses: n})">{{ n }}</label>
                                      </li>
                                    </template>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td class="ta-center">
                            <div v-show="item.is_bought"
                              @click="group1.onResetButtonClicked({item: item})"
                              class="license-content-table-reset" role="button"
                            >
                              <div class="license-content-table-reset-tip">リセット</div>
                              <FontawesomeIcon :icon="['far','eraser']" size="lg" class="icn"/>
                            </div>
                          </td>
                          <td class="ta-right">
                            <div class="license-content-table-price">
                              <span v-if="!item.is_bought">-</span>
                              <span v-else>{{ item.priceDisp }} 円</span>
                            </div>
                            <div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </template>
                </template>

              </div>

              <h2 class="hdg03">決済方法選択</h2>
              <p class="contact-content-lead sp-ml20 sp-mr20">決済方法を選択してください。</p>
              <div class="list-inline select-option mb12">
                <div class="formparts radio inline">
                  <input type="radio" name="group_rb_01" id="rd_01_01" v-model="group1.radioPaymentMethod" :value="1" checked>
                  <label for="rd_01_01">クレジットカード / 口座振替</label>
                </div>
                <div class="formparts radio inline">
                  <input type="radio" name="group_rb_01" id="rd_01_02" v-model="group1.radioPaymentMethod" :value="2">
                  <label for="rd_01_02">銀行振込（WEB請求書）</label>
                </div>
              </div>
              <p class="txt">以下の必要事項についてご記入を完了してください</p>
              <p class="txt-sup mb12">※ご記入中に新日本法規WEBサイトからログアウトあるいはタイムアウトになった場合は、新日本法規WEBサイトのログイン画面が表示されますので、再度ログインしてください。</p>
              <div v-if="group1.isOfferCodeUnapplied" class="payment-application mb40">
                <iframe v-show="group1.radioPaymentMethod === 1" class="iframe -creditCard" src="/shop/account/iframe/lc/autopaymentrequest" frameborder="0"></iframe>
                <iframe v-show="group1.radioPaymentMethod === 2" class="iframe -bankTransfer" src="/shop/account/iframe/lc/paymentrequest" frameborder="0"></iframe>
              </div>

              <div v-if="group1.isOfferCodeAappliedNoContract" class="mt40 mb40 sp-ml20 sp-mr20">
                <h3 class="hdg03 ta-center">決済申請は完了しております。</h3>
                <p class="txt txt-red txt-bold ta-center mb12">【ご注意】お申し込みは完了していません。</p>
                <p class="txt ta-center mb12">下記ボタンを押下してお進みください。</p>
              </div>

              <div v-if="group1.isOfferCodeContracted" class="mt40 mb40 sp-ml20 sp-mr20">
                <h3 class="hdg03 ta-center">LEGAL CONNECTIONはご契約済です</h3>
                <p class="txt ta-center mb12">ログインしてご利用ください。</p>
                <p class="ta-center"><router-link :to="`/${ group1.device }/login`" class="txt-blue">LEGAL CONNECTIONログイン</router-link></p>
              </div>

              <div class="offer-code mb40">
                <p v-if="group1.error_offerCode" class="error-message mt16">{{ group1.error_offerCode }}</p>
              </div>

              <h2 class="hdg04 sp-ml20">個人情報の取り扱いについて</h2>
              <p class="txt sp-ml20">
                お客様の個人情報は、本人確認、お問い合わせ対応および各種ご案内の送付などの業務活動並びに当社の定める利用目的の範囲内で、当社の関連会社や協力会社に対して提供する場合があります。<br>
                本ページ記載事項（規約を含む）を必ずご確認いただきますようお願いいたします。本ページ記載事項（規約を含む）にご同意いただいた場合は、[同意した上で進む]ボタンをクリックして確認画面へお進みください。
              </p>
              <ul class="list-inline mt12 sp-ml20 sp-mr20">
                <li>
                  <a href="https://www.sn-hoki.co.jp/guide/social_rules/" class="txt-blue" target="_blank">利用規約 <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
                </li>
                <li>
                  <a href="https://www.sn-hoki.co.jp/privacy/" class="txt-blue" target="_blank">プライバシーポリシー <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
                </li>
              </ul>

              <div class="contact-submit">
                <div class="button contact-submit-button" :class="{ 'is-inactive': group1.isOfferCodeContracted }">
                  <button class="btn mb60" @click="group1.onSubmitButtonClicked">同意した上で進む</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box-total">
        <p class="total-txt">ご請求金額 合計
          <span class="total-amount">{{ group1.totalFreeDisp }}</span>
          円（税込）
        </p>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
// import '@/components/style/RESCommonCSS.vue'
import store from '@/store'
import NewApplicationPostnumberDuplicated from '@/components/public/new-application/popup/NewApplicationPostnumberDuplicated.vue'
import * as logicNewApplication from '@/logic/public/NewApplication'

export default defineComponent({
  components: {
    NewApplicationPostnumberDuplicated
  },
  beforeRouteEnter (to, from, next) {
    console.log('[NewApplicationIndex:beforeRouteEnter]', { to, from })

    if (from.name !== 'NewApplicationConfirm') {
      // 確認画面以外から遷移して来た場合はストアに保持している値を全クリア
      store.dispatch('inquiry/clearAllStates')
      store.dispatch('newApplication/clearAllStates')
    }

    next()
  },
  setup (props, context) {
    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicNewApplication.getGroupIndex(props, context)

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
.contact {
  @media screen and (max-width:$width-container) {
    &-head {
      .hdg02 {
        padding-top: 20px;
      }
    }
  }
}

.payment-application {
  @media screen and (max-width: 768px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  .iframe {
    display: block;
    width: 100%;
    max-width: 768px;
    border: 1px solid $color-line;
    margin-left: auto;
    margin-right: auto;
    &.-creditCard {
      height: 702px;
      @media screen and (max-width: 768px) {
        height: 720px;
      }
    }
    &.-bankTransfer {
      height: 500px;
      @media screen and (max-width: 768px) {
        height: 500px;
      }
    }
  }
}

.offer-code {
  .column {
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
  }
}
.box-total {
  background: #F9F8F6;
  border-radius: 8px 8px 0 0;
  margin: 20px 0 0;
  padding: 20px;
  text-align: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  .total-txt {
    color: $color-link;
    font-weight: bold;
    font-size: 1.8rem;
  }
  .total-amount {
    display: inline-block;
    font-size: 2.4rem;
    margin: 0 0 0 0.5em;
  }
}
#wrapper {
  padding-bottom: 0!important;
}
</style>
